

















import Vue from 'vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import StorePicker from '@/components/molecules/StorePicker/StorePicker.vue'
import PARTNER_QUERY from '@/graphql/user/myPartners.gql'
import { Query } from '@/types/generated/graphql'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'

export type Input = {
  storeId?: string
}

type Data = {
  input: Input
}

export default Vue.extend<Data, {}, {}, {}>({
  name: 'SubscriptionSearch',
  components: { XCard, StorePicker, XFormLabel },
  props: {
    input: {
      type: Object,
    },
  },
  apollo: {
    partnerId: {
      query: PARTNER_QUERY,
      update({ myPartners }: Query) {
        // FIXME 所属しているパートナーは1件の前提
        return myPartners[0].partnerId
      },
      fetchPolicy: 'network-only',
    },
  },
})
